import getCookies from './cookies';
import getDocument from '@loggi/js/get-document';

/* 
This module returns user's referrer. Loggi's application always
write a cookie with the original user's referral URL.
This method is a helper to read referral value from this cookie or
from `document` object.
 */

const REFERRER_COOKIE = 'referral_source';

export default function getReferrer(fromCookie = true) {
  if (fromCookie) {
    const cookies = getCookies();
    return cookies[REFERRER_COOKIE] || null;
  } else {
    const document = getDocument();
    return document === null ? null : document.referrer || null;
  }
}
